import MedicalNoteModal from './MedicalNoteModal';

export default MedicalNoteModal;
